import React, {useState, useEffect, useRef} from "../../../../__snowpack__/pkg/react.js";
import {Button, Descriptions, Modal, notification, Progress, message} from "../../../../__snowpack__/pkg/antd.js";
import {IconSuccess, IconWarning, IconError} from "../../../../__snowpack__/pkg/@genieui-react/icon.js";
import {axios} from "../../../lib/axios.js";
import {handleError} from "../../../lib/errorHandler.js";
import styled from "../../../../__snowpack__/pkg/styled-components.js";
import {eventLogger} from "../../../lib/eventLogger.js";
export const PullStockModal = (props) => {
  const [isInProgress, setIsInProgress] = useState(true);
  const maxTry = 3600;
  const tryCount = useRef(0);
  const visibleRef = useRef(false);
  const [taskResultData, setTaskResultData] = useState(null);
  const getTaskResultPeriodically = async (taskId) => {
    tryCount.current++;
    return await new Promise(async (resolve, reject) => {
      try {
        const res = await axios.get(`/saas/ims/tasks?taskId=${taskId}`);
        if (res && res.data) {
          if (["finish"].includes(res.data.status)) {
            resolve(res);
          } else {
            await new Promise((r) => setTimeout(r, 1e3));
            if (visibleRef.current && tryCount.current <= maxTry) {
              resolve(getTaskResultPeriodically(taskId));
            }
          }
        } else {
          reject();
        }
      } catch (error) {
        reject(error);
        eventLogger.push(props.eventLoggerOptions.failed);
      }
    });
  };
  const handleGetTaskResult = async (taskId) => {
    if (!taskId)
      return;
    await new Promise((r) => setTimeout(r, 200));
    const res = await getTaskResultPeriodically(taskId);
    setTaskResultData(res.data);
    setIsInProgress(false);
    if (res.data?.status === "error") {
      eventLogger.push(props.eventLoggerOptions.failed);
    } else if (res.data?.status === "finish") {
      if (res.data?.failNum > 0 && !(res.data?.successNum > 0)) {
        eventLogger.push(props.eventLoggerOptions.failed);
      } else {
        eventLogger.push(props.eventLoggerOptions.success);
      }
    }
    if (res.data && res.data.errorMsg) {
      notification.error({
        message: "Tips",
        description: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", {
          style: {wordBreak: "break-all"}
        }, res.data.errorMsg), /* @__PURE__ */ React.createElement("div", {
          style: {
            textAlign: "right",
            padding: "8px 0",
            opacity: 0.5,
            color: "#bfbfbf",
            fontSize: "12px"
          }
        }, res.transactionId)),
        duration: 4
      });
    }
  };
  const doPullStock = async () => {
    const params = {};
    if (props.fulfillmentType) {
    }
    if (props.shelfInventoryList) {
      params.shelfInventoryList = props.shelfInventoryList || [];
      params.warehouseId = props.warehouseId || "";
    } else {
      params.warehouseId = props.warehouseId || "";
    }
    try {
      const res = await axios.post(props.api, params, {
        timeout: 60 * 1e3
      });
      if (props.noAskReaslutSync) {
        if (res?.code === "SUCCESS") {
          message.success(props.formatMessage({id: "globalTaskSuccess"}));
        } else {
          message.error(props.formatMessage({id: "globalTaskFailed"}));
        }
        props.handleLoading(false);
        return res;
      }
      if (res && res.data) {
        const taskId = typeof res.data === "string" ? res.data : "";
        await handleGetTaskResult(taskId);
      }
    } catch (error) {
      handleError(error);
      setIsInProgress(false);
      eventLogger.push(props.eventLoggerOptions.failed);
    } finally {
      props.handleLoading(false);
    }
  };
  const completePercent = taskResultData ? taskResultData.status === "finish" ? 100 : Math.round(100 * (taskResultData.successNum + taskResultData.failNum) / taskResultData.total) || 0 : 0;
  const emptyToDashFilter = (value) => {
    return [void 0, null, ""].includes(value) ? "-" : value;
  };
  useEffect(() => {
    visibleRef.current = props.visible;
    if (props.visible || props.noAskReaslutSync) {
      doPullStock();
    } else {
      tryCount.current = 0;
      setTaskResultData(null);
      setIsInProgress(true);
    }
  }, [props.visible, props.noAskReaslutSync]);
  const handleDownloadFailedData = () => {
    if (taskResultData && taskResultData.failExcelUrl) {
      window.open(taskResultData.failExcelUrl);
    } else {
      notification.info({message: props.formatMessage({id: "noData"})});
    }
  };
  const handleSeeStockPullRecord = () => {
    window.open("/stock-pull-record");
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Modal, {
    destroyOnClose: true,
    maskClosable: false,
    visible: props.visible,
    title: isInProgress ? props.formatMessage({id: "processing"}) : props.formatMessage({id: "result"}),
    onCancel: () => {
      props.setModalVisible(false);
    },
    footer: isInProgress ? null : [
      ...(taskResultData?.failNum > 0 || taskResultData?.status === "error") && taskResultData?.failExcelUrl ? [
        /* @__PURE__ */ React.createElement(Button, {
          type: "primary",
          key: "3",
          onClick: handleDownloadFailedData
        }, props.formatMessage({id: "downloadFailedData"}))
      ] : [],
      /* @__PURE__ */ React.createElement(Button, {
        type: "primary",
        key: "2",
        onClick: handleSeeStockPullRecord
      }, props.formatMessage({id: "seeDetails"}))
    ]
  }, /* @__PURE__ */ React.createElement("div", {
    style: {paddingBottom: 12}
  }, isInProgress ? props.formatMessage({id: "processing"}) : taskResultData?.status === "error" || taskResultData?.failNum > 0 && !(taskResultData?.successNum > 0) ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IconError, {
    width: 16,
    height: 16,
    style: {marginRight: 8, verticalAlign: "middle"}
  }), props.formatMessage({id: "failed"})) : taskResultData?.successNum > 0 && taskResultData?.failNum > 0 ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IconWarning, {
    width: 16,
    height: 16,
    style: {marginRight: 8, verticalAlign: "middle"}
  }), props.formatMessage({id: "partFailed"})) : taskResultData?.status === "finish" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IconSuccess, {
    width: 16,
    height: 16,
    style: {marginRight: 8, verticalAlign: "middle"}
  }), props.formatMessage({id: "operationSuccessful"})) : props.formatMessage({id: "processing"})), /* @__PURE__ */ React.createElement(Progress, {
    percent: completePercent,
    type: "line",
    showInfo: false,
    strokeColor: {from: "#B699FF", to: "#4C04FF"},
    strokeWidth: 17,
    status: isInProgress ? "active" : "normal",
    style: {marginBottom: 16}
  }), !isInProgress && /* @__PURE__ */ React.createElement(DescriptionsWrapper, null, /* @__PURE__ */ React.createElement(Descriptions, {
    column: 1,
    bordered: true,
    labelStyle: {
      width: "34%",
      color: "#161344",
      textAlign: "right",
      paddingRight: 24,
      backgroundColor: "#F5F7FA"
    },
    contentStyle: {paddingLeft: 24},
    style: {paddingBottom: 24}
  }, /* @__PURE__ */ React.createElement(Descriptions.Item, {
    label: props.formatMessage({id: "totalNumber"}),
    contentStyle: {color: "#202D40"}
  }, emptyToDashFilter(taskResultData?.total)), /* @__PURE__ */ React.createElement(Descriptions.Item, {
    label: props.formatMessage({id: "successfulNumber"}),
    contentStyle: {color: "#66BE75"}
  }, emptyToDashFilter(taskResultData?.successNum)), /* @__PURE__ */ React.createElement(Descriptions.Item, {
    label: props.formatMessage({id: "failedNumber"}),
    contentStyle: {color: "#E7192C"}
  }, emptyToDashFilter(taskResultData?.failNum))))));
};
const DescriptionsWrapper = styled.div`
  .ant-descriptions-view,
  .ant-descriptions-row {
    border-color: #dfe3e8;
  }
`;
